var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 21.2H8.45818L5.11059 2.78827C5.07038 2.56708 4.9538 2.36701 4.7812 2.22296C4.60859 2.0789 4.3909 2 4.16608 2H2",
    stroke: "#3D9F4A",
    strokeWidth: 2.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68003 26C11.0055 26 12.08 24.9255 12.08 23.6C12.08 22.2745 11.0055 21.2 9.68003 21.2C8.35455 21.2 7.28003 22.2745 7.28003 23.6C7.28003 24.9255 8.35455 26 9.68003 26Z",
    stroke: "#3D9F4A",
    strokeWidth: 2.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 26C23.4855 26 24.56 24.9255 24.56 23.6C24.56 22.2745 23.4855 21.2 22.16 21.2C20.8345 21.2 19.76 22.2745 19.76 23.6C19.76 24.9255 20.8345 26 22.16 26Z",
    stroke: "#3D9F4A",
    strokeWidth: 2.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58542 16.4H22.6521C23.1018 16.4 23.5371 16.2422 23.8824 15.9541C24.2276 15.666 24.4607 15.2659 24.5412 14.8235L26 6.80002H5.83997",
    stroke: "#3D9F4A",
    strokeWidth: 2.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.129c3222dd285247d876d7f56860f457.svg";
export { ForwardRef as ReactComponent };